import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { X, Check, Wind, AlertTriangle, Star, Sparkles } from 'lucide-react';
export function PlusUpsell() {
  return <section className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <div className="inline-flex items-center gap-2 bg-urgency-red text-white font-bold px-4 py-1.5 rounded-full text-xs mb-4 tracking-widest shadow-md" data-id="element-193">
            <Sparkles size={14} data-id="element-194" />
            UPGRADE PLUS
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-gray-900 mb-3" data-id="element-195">
            ¿Qué agrega el <span className="text-urgency-red" data-id="element-196">PLUS</span>?
          </h2>
          <p className="text-lg text-gray-600 font-medium" data-id="element-197">
            Para estudiantes que quieren la colección completa sin excepción
          </p>
        </div>

        {/* Hero comparison with image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden mb-12 border border-gray-100" data-id="element-198">
          <div className="grid md:grid-cols-2" data-id="element-199">
            {/* Image side */}
            <div className="relative h-64 md:h-auto overflow-hidden" data-id="element-200">
              <img src="https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?auto=format&fit=crop&w=1000&q=80" alt="Urgencias respiratorias y toxicología" className="w-full h-full object-cover" loading="lazy" data-id="element-201" />
              <div className="absolute inset-0 bg-gradient-to-tr from-medical-blue/80 via-medical-blue/40 to-transparent" data-id="element-202"></div>
              <div className="absolute bottom-6 left-6 right-6" data-id="element-203">
                <div className="inline-block bg-urgency-red text-white text-xs font-bold px-3 py-1 rounded-full mb-3 shadow-lg" data-id="element-204">
                  + 2 TOMOS EXTRA
                </div>
                <h3 className="font-heading text-white text-2xl md:text-3xl font-extrabold leading-tight" data-id="element-205">
                  Sistema completo de respiratorio + toxicología
                </h3>
              </div>
            </div>

            {/* Comparison side */}
            <div className="p-6 md:p-8 flex flex-col justify-center" data-id="element-206">
              <div className="bg-red-50 rounded-xl p-4 mb-4 border-l-4 border-urgency-red" data-id="element-207">
                <div className="flex items-center gap-2 mb-2" data-id="element-208">
                  <div className="bg-urgency-red text-white rounded-full p-1" data-id="element-209">
                    <X size={12} strokeWidth={3} data-id="element-210" />
                  </div>
                  <span className="font-bold text-urgency-red text-xs md:text-sm uppercase tracking-wider" data-id="element-211">
                    Sin PLUS
                  </span>
                </div>
                <p className="text-gray-700 text-xs md:text-sm leading-relaxed" data-id="element-212">
                  Salís de guardia sin saber manejar la crisis asmática severa
                  ni el EPOC descompensado. Frente a una intoxicación no sabés
                  reconocer el toxidrome ni recordás el antídoto correcto.
                </p>
              </div>

              <div className="bg-green-50 rounded-xl p-4 border-l-4 border-success-green" data-id="element-213">
                <div className="flex items-center gap-2 mb-2" data-id="element-214">
                  <div className="bg-success-green text-white rounded-full p-1" data-id="element-215">
                    <Check size={12} strokeWidth={3} data-id="element-216" />
                  </div>
                  <span className="font-bold text-success-green text-xs md:text-sm uppercase tracking-wider" data-id="element-217">
                    Con PLUS
                  </span>
                </div>
                <p className="text-gray-900 font-medium text-xs md:text-sm leading-relaxed" data-id="element-218">
                  Sistema completo: VMNI en EPOC, crisis asmática casi fatal,
                  tabla maestra de toxidromes, antídotos con ventana terapéutica
                  y los casos más frecuentes de intoxicación en Argentina.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Included badge */}
        <div className="text-center mb-8" data-id="element-219">
          <div className="inline-flex items-center gap-2 bg-medical-blue text-white font-bold px-5 py-2 rounded-full text-sm shadow-md" data-id="element-220">
            <Star size={16} className="text-accent-gold" fill="currentColor" data-id="element-221" />
            EL PLUS INCLUYE
            <Star size={16} className="text-accent-gold" fill="currentColor" data-id="element-222" />
          </div>
        </div>

        {/* The two extra tomos */}
        <div className="grid md:grid-cols-2 gap-6" data-id="element-223">
          {/* Tomo 7 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-gray-100 hover:border-medical-blue transition-colors" data-id="element-224">
            <div className="relative h-44 overflow-hidden" data-id="element-225">
              <img src="https://images.unsplash.com/photo-1584516150909-c43483ee7932?auto=format&fit=crop&w=800&q=80" alt="Urgencias Respiratorias" className="w-full h-full object-cover" loading="lazy" data-id="element-226" />
              <div className="absolute inset-0 bg-gradient-to-t from-medical-blue/90 via-medical-blue/40 to-transparent" data-id="element-227"></div>
              <div className="absolute top-3 left-3 bg-white text-medical-blue font-black text-sm px-3 py-1 rounded-lg shadow-md" data-id="element-228">
                T7
              </div>
              <div className="absolute bottom-3 left-3 right-3" data-id="element-229">
                <div className="flex items-center gap-2" data-id="element-230">
                  <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg text-white border border-white/30" data-id="element-231">
                    <Wind size={20} data-id="element-232" />
                  </div>
                  <h4 className="font-heading font-bold text-white text-lg leading-tight" data-id="element-233">
                    Urgencias Respiratorias
                  </h4>
                </div>
              </div>
            </div>
            <div className="p-5" data-id="element-234">
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-235">
                EPOC descompensado, asma grave, neumonía, insuficiencia
                respiratoria aguda y criterios de intubación.
              </p>
            </div>
          </motion.div>

          {/* Tomo 8 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden border-2 border-gray-100 hover:border-urgency-red transition-colors" data-id="element-236">
            <div className="relative h-44 overflow-hidden" data-id="element-237">
              <img src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&w=800&q=80" alt="Toxicología y Sobredosis" className="w-full h-full object-cover" loading="lazy" data-id="element-238" />
              <div className="absolute inset-0 bg-gradient-to-t from-urgency-red/90 via-urgency-red/40 to-transparent" data-id="element-239"></div>
              <div className="absolute top-3 left-3 bg-white text-urgency-red font-black text-sm px-3 py-1 rounded-lg shadow-md" data-id="element-240">
                T8
              </div>
              <div className="absolute bottom-3 left-3 right-3" data-id="element-241">
                <div className="flex items-center gap-2" data-id="element-242">
                  <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg text-white border border-white/30" data-id="element-243">
                    <AlertTriangle size={20} data-id="element-244" />
                  </div>
                  <h4 className="font-heading font-bold text-white text-lg leading-tight" data-id="element-245">
                    Toxicología y Sobredosis
                  </h4>
                </div>
              </div>
            </div>
            <div className="p-5" data-id="element-246">
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-247">
                Los 5 toxidromes, opioides, organofosforados, paracetamol, CO y
                drogas de abuso frecuentes en Argentina.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}